import React from 'react';
import { AppBar, Toolbar, Typography, Button, Stack, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function LandingPageLayoutDesktop({ children }) {
  const navigate = useNavigate();

  const sections = ['hero', 'problema', 'soluzioni', 'testimonianze', 'prezzi', 'contatti', 'accedi', 'registrati'];

  const scrollToSection = (id) => {
    if (id === 'accedi') navigate('/login');
    else if (id === 'registrati') navigate('/register');
    else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box>
      <AppBar position="fixed" sx={{ bgcolor: '#fff', color: '#000', boxShadow: '0 1px 8px rgba(0,0,0,0.05)' }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Typography sx={{ fontWeight: 700 }}>DeskStudio</Typography>

          <Stack direction="row" spacing={2}>
            {sections.map(sec => (
              <Button
                key={sec}
                onClick={() => scrollToSection(sec)}
                sx={{ textTransform: 'none', fontWeight: 500 }}
              >
                {sec}
              </Button>
            ))}
          </Stack>
        </Toolbar>
      </AppBar>

      <Box sx={{ mt: 10 }}>
        {children}
      </Box>
    </Box>
  );
}